import React, { useEffect, useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { AnimatePresence, motion } from 'framer-motion';
import { Globe, Menu, X } from 'lucide-react';
export function Navbar() {
  const {
    language,
    setLanguage,
    t
  } = useLanguage();
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: t.nav.home,
    href: '#home'
  }, {
    name: t.nav.experience,
    href: '#boat'
  }, {
    name: t.nav.gallery,
    href: '#gallery'
  }, {
    name: t.nav.reviews,
    href: '#reviews'
  }, {
    name: t.nav.faq,
    href: '#faq'
  }];
  const toggleLanguage = () => setLanguage(language === 'es' ? 'en' : 'es');
  const navigationColor = isScrolled ? 'text-gray-700' : 'text-white drop-shadow-md';
  return <nav className={`fixed w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-md shadow-sm py-3' : 'bg-transparent py-5'}`} data-id="element-101">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-102">
        <div className="flex justify-end items-center" data-id="element-103">
          <div className="hidden md:flex items-center space-x-8" data-id="element-104">
            {navLinks.map(link => <a key={link.href} href={link.href} className={`text-sm font-medium transition-colors hover:text-turquoise ${navigationColor}`} data-id="element-105">
                {link.name}
              </a>)}
            <button type="button" onClick={toggleLanguage} className={`flex items-center gap-1 text-sm font-bold px-3 py-1 rounded-full border transition-colors ${isScrolled ? 'border-gray-300 text-gray-700 hover:bg-gray-100' : 'border-white/50 text-white hover:bg-white/20'}`} aria-label="Change language" data-id="element-106">
              <Globe size={16} data-id="element-107" />
              {language.toUpperCase()}
            </button>
          </div>

          <div className="md:hidden flex items-center gap-4" data-id="element-108">
            <button type="button" onClick={toggleLanguage} className={`flex items-center gap-1 text-sm font-bold ${navigationColor}`} aria-label="Change language" data-id="element-109">
              <Globe size={18} data-id="element-110" />
              {language.toUpperCase()}
            </button>
            <button type="button" onClick={() => setMobileMenuOpen(open => !open)} className={navigationColor} aria-expanded={mobileMenuOpen} aria-controls="mobile-navigation" aria-label="Toggle navigation menu" data-id="element-111">
              {mobileMenuOpen ? <X size={24} data-id="element-112" /> : <Menu size={24} data-id="element-113" />}
            </button>
          </div>
        </div>
      </div>

      <AnimatePresence data-id="element-114">
        {mobileMenuOpen && <motion.div id="mobile-navigation" initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} transition={{
        duration: 0.2,
        ease: 'easeOut'
      }} className="md:hidden bg-white border-t border-gray-100 shadow-xl overflow-hidden" data-id="element-115">
            <div className="px-4 pt-2 pb-6 space-y-1" data-id="element-116">
              {navLinks.map(link => <a key={link.href} href={link.href} onClick={() => setMobileMenuOpen(false)} className="block px-3 py-3 text-base font-medium text-gray-800 hover:bg-gray-50 hover:text-turquoise rounded-md" data-id="element-117">
                  {link.name}
                </a>)}
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}